import React, { useState } from "react";
import TripDetailsBanner from "../assets/media/SortedTrips.jpg";
import TripDetailsFormAPI from "../api/TripDetailsFormAPI";
import toast from "react-hot-toast";

const TripDetailsForm = () => {
  const [tripDetailsInfo, setTripDetailsInfo] = useState({
    name: "",
    email: "",
    mobile: "",
    no_days: "",
    number_of_people: "",
    preferred_date: "",
    preferred_location: "",
  });

  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  // Helper function to render required asterisk
  const renderRequiredAsterisk = () => <span style={{ color: 'red' }}>*</span>;

  // Validation function similar to ContactUs.jsx
  const validateForm = () => {
    const newErrors = {};
    const nameRegex = /^[A-Za-z ]{2,}$/;
    const emailRegex = /^[A-Za-z0-9]+@[A-Za-z0-9]+\.[A-Za-z0-9]+$/;
    const mobileRegex = /^[6-9]\d{9}$/;
    const locationRegex = /^[A-Za-z0-9\s,.\-]+$/;

    if (!tripDetailsInfo.name.trim()) {
      newErrors.name = "Name is required";
    } else if (!nameRegex.test(tripDetailsInfo.name)) {
      newErrors.name = "Please enter a valid name (minimum 2 characters, letters only)";
    }

    if (!tripDetailsInfo.email) {
      newErrors.email = "Email is required";
    } else {
      if ((tripDetailsInfo.email.match(/@/g) || []).length !== 1) {
        newErrors.email = "Email must contain exactly one @";
      } else if ((tripDetailsInfo.email.split('@')[1] || '').split('.').length !== 2) {
        newErrors.email = "Email must contain exactly one . after @";
      } else if (!emailRegex.test(tripDetailsInfo.email)) {
        newErrors.email = "Email can only contain letters, numbers, @, and .";
      } else if (tripDetailsInfo.email.endsWith('.')) {
        newErrors.email = "Email cannot end with a dot (.)";
      }
    }

    if (!tripDetailsInfo.mobile) {
      newErrors.mobile = "Mobile number is required";
    } else if (!mobileRegex.test(tripDetailsInfo.mobile)) {
      newErrors.mobile = "Please enter a valid 10-digit mobile number starting with 6-9";
    }

    if (!tripDetailsInfo.preferred_date) {
      newErrors.preferred_date = "Preferred date is required";
    } else {
      const selectedDate = new Date(tripDetailsInfo.preferred_date);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      if (selectedDate < today) {
        newErrors.preferred_date = "Preferred date cannot be in the past";
      }
    }

    if (!tripDetailsInfo.preferred_location.trim()) {
      newErrors.preferred_location = "Location is required";
    } else if (!locationRegex.test(tripDetailsInfo.preferred_location)) {
      newErrors.preferred_location = "Only letters, numbers, spaces, commas, dots, and hyphens allowed.";
    }

    if (!tripDetailsInfo.no_days) {
      newErrors.no_days = "Number of days is required";
    } else if (isNaN(Number(tripDetailsInfo.no_days)) || Number(tripDetailsInfo.no_days) < 1) {
      newErrors.no_days = "Number of days must be at least 1";
    }

    if (!tripDetailsInfo.number_of_people) {
      newErrors.number_of_people = "Number of people is required";
    } else if (isNaN(Number(tripDetailsInfo.number_of_people)) || Number(tripDetailsInfo.number_of_people) < 1) {
      newErrors.number_of_people = "Number of people must be at least 1";
    }

    return newErrors;
  };

  // Handle input change
  let handleTripsDetailsInfo = (e) => {
    let { name, value } = e.target;
    if (name === "name") {
      value = value.replace(/[^A-Za-z\s]/g, "");
    }
    setTripDetailsInfo((prev) => ({ ...prev, [name]: value }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  // Handle field blur to mark as touched
  const handleFieldBlur = (e) => {
    const { name } = e.target;
    setTouched((prev) => ({ ...prev, [name]: true }));
  };

  let handleFormSubmit = async (e) => {
    e.preventDefault();
    // Mark all fields as touched when form is submitted
    setTouched({
      name: true,
      email: true,
      mobile: true,
      no_days: true,
      number_of_people: true,
      preferred_date: true,
      preferred_location: true,
    });
    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      // toast.error("Please correct the form errors.");
      return;
    }
    try {
      const response = await TripDetailsFormAPI.postTripDetailsForm(
        tripDetailsInfo
      );
      if (response.code === 200) {
        toast.success("Message Sent Successfully!");
        setTripDetailsInfo({
          name: "",
          email: "",
          mobile: "",
          preferred_date: "",
          preferred_location: "",
          no_days: "",
          number_of_people: "",
        });
        setErrors({});
        setTouched({});
      }
    } catch (error) {
      console.error("Submission error:", error);
      toast.error("Something went wrong.");
    }
  };

  return (
    <>
      {/* <style>{`
        .form-control.is-invalid {
          border-color: #dc3545 !important;
          box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
        }
        .error-message {
          display: block;
          width: 100%;
          margin-top: 0.25rem;
          font-size: 0.875em;
          color: #dc3545;
        }
        .form-control {
          display: block;
          width: 100%;
          padding: 0.375rem 0.75rem;
          font-size: 1rem;
          font-weight: 400;
          line-height: 1.5;
          color: #212529;
          background-color: #fff;
          background-clip: padding-box;
          border: 1px solid #ced4da;
          border-radius: 0.375rem;
          transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        }
        .form-control:focus {
          color: #212529;
          background-color: #fff;
          border-color: #86b7fe;
          outline: 0;
          box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
        }
        .field-label {
          margin-bottom: 0.5rem;
          font-weight: 500;
        }
      `}</style> */}
      <section className="custom-trip-details-section container-fluid d-flex flex-column justify-content-center align-items-center p-0">
        <h1 className="mt-4">Customize Your Trip</h1>
        <p className="px-4 px-md-0 px-lg-0">Every traveller is unique - let’s craft a trip that feels like you.</p>
        <div
          className="row custom-trip-main-row m-0 mb-5"
          style={{ border: "1px solidrgb(184, 186, 189)" }}
        >
          <div className=" col-12 col-md-12 col-lg-6 col-xl-6 p-0 mb-2 mb-md-3 mb-lg-0 mb-xl-0">
            <div className="custom-trip-planner-img">
              <img src={TripDetailsBanner} alt="" />
            </div>
          </div>
          <div className="col-12 col-md-12 col-lg-6 col-xl-6 custom-trip-details-form-container">
            <h4 className="text-center mb-4">
              Add your details and let our experts create a Sorted Trip just for you.
            </h4>
            <form
              className="row custom-trip-details-form d-flex justify-content-between  gap-2 px-4"
              onSubmit={handleFormSubmit}
            >
              <div className="col-12 col-md-12 col-lg-12 col-xl-12 mb-1">
                <div className="field-label">
                  Name {renderRequiredAsterisk()}
                </div>
                <input
                  type="text"
                  name="name"
                  value={tripDetailsInfo.name}
                  onChange={handleTripsDetailsInfo}
                  onBlur={handleFieldBlur}
                  className={`form-control ${touched.name && errors.name ? 'is-invalid' : ''}`}
                  placeholder="Name"
                />
                {touched.name && errors.name && (
                  <div className="error-message">{errors.name}</div>
                )}
              </div>
              <div className="col-12 col-md-12 col-lg-12 col-xl-12 mb-1">
                <div className="field-label">
                  Email {renderRequiredAsterisk()}
                </div>
                <input
                  type="text"
                  name="email"
                  value={tripDetailsInfo.email}
                  onChange={handleTripsDetailsInfo}
                  onBlur={handleFieldBlur}
                  className={`form-control ${touched.email && errors.email ? 'is-invalid' : ''}`}
                  placeholder="Email"
                />
                {touched.email && errors.email && (
                  <div className="error-message">{errors.email}</div>
                )}
              </div>
              <div className="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 mb-1">
                <div className="field-label">
                  Phone Number {renderRequiredAsterisk()}
                </div>
                <input
                  type="tel"
                  name="mobile"
                  value={tripDetailsInfo.mobile}
                  onChange={e => {
                    // Only allow digits
                    const value = e.target.value.replace(/\D/g, '');
                    handleTripsDetailsInfo({ target: { name: 'mobile', value } });
                  }}
                  onBlur={handleFieldBlur}
                  className={`form-control ${touched.mobile && errors.mobile ? 'is-invalid' : ''}`}
                  placeholder="Phone Number"
                />
                {touched.mobile && errors.mobile && (
                  <div className="error-message">{errors.mobile}</div>
                )}
              </div>
              <div className="col-12 col-md-5 col-lg-5 col-xl-5 mb-1">
                <div className="field-label">
                  Number of Days {renderRequiredAsterisk()}
                </div>
                <input
                  type="number"
                  name="no_days"
                  value={tripDetailsInfo.no_days}
                  onChange={handleTripsDetailsInfo}
                  onBlur={handleFieldBlur}
                  className={`form-control ${touched.no_days && errors.no_days ? 'is-invalid' : ''}`}
                  placeholder="Number of Days"
                />
                {touched.no_days && errors.no_days && (
                  <div className="error-message">{errors.no_days}</div>
                )}
              </div>
              <div className="col-12 col-md-5 col-lg-5 col-xl-5 mb-1">
                <div className="field-label">
                  Number of People {renderRequiredAsterisk()}
                </div>
                <input
                  type="number"
                  name="number_of_people"
                  value={tripDetailsInfo.number_of_people}
                  onChange={handleTripsDetailsInfo}
                  onBlur={handleFieldBlur}
                  className={`form-control ${touched.number_of_people && errors.number_of_people ? 'is-invalid' : ''}`}
                  placeholder="Number of people"
                />
                {touched.number_of_people && errors.number_of_people && (
                  <div className="error-message">{errors.number_of_people}</div>
                )}
              </div>
              <div className="col-12 col-md-5 col-lg-5 col-xl-5 mb-1">
                <div className="field-label">
                  Preferred Date {renderRequiredAsterisk()}
                </div>
                <input
                  type="date"
                  name="preferred_date"
                  value={tripDetailsInfo.preferred_date}
                  onChange={handleTripsDetailsInfo}
                  onBlur={handleFieldBlur}
                  min={new Date().toISOString().split('T')[0]}
                  className={`form-control ${touched.preferred_date && errors.preferred_date ? 'is-invalid' : ''}`}
                  placeholder="Preferred Date"
                />
                {touched.preferred_date && errors.preferred_date && (
                  <div className="error-message">{errors.preferred_date}</div>
                )}
              </div>
              <div className="col-12 col-md-12 col-lg-12 col-xl-12 mb-1">
                <div className="field-label">
                  Preferred Location {renderRequiredAsterisk()}
                </div>
                <input
                  type="text"
                  name="preferred_location"
                  value={tripDetailsInfo.preferred_location}
                  onChange={e => {
                    // Only allow valid characters
                    const value = e.target.value.replace(/[^A-Za-z0-9\s,.\-]/g, '');
                    handleTripsDetailsInfo({ target: { name: 'preferred_location', value } });
                  }}
                  onBlur={handleFieldBlur}
                  className={`form-control ${touched.preferred_location && errors.preferred_location ? 'is-invalid' : ''}`}
                  placeholder="Preferred Location"
                />
                {touched.preferred_location && errors.preferred_location && (
                  <div className="error-message">{errors.preferred_location}</div>
                )}
              </div>
              <div className="col-xl-12 text-center pb-md-2">
                <button type="submit" className="custom-enquiry-btn">
                  Enquire Now
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default TripDetailsForm;
